<div class="email-disclaimer-note">
    <span *ngIf="showDisclaimer">{{message}}</span>
</div>
